import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
// import { ThemeProvider } from "contexts/themeContexts";
import { ToastContainer, cssTransition } from "react-toastify";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import { ThemeProvider } from "@zendeskgarden/react-theming";
import { store, persistor } from "redux/store";
import "react-toastify/dist/ReactToastify.css";
import "react-quill/dist/quill.snow.css";

import "./index.css";
import "./index.scss";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

const TopTORight = cssTransition({
  enter: "cs-top-right-in",
  exit: "cs-top-right-out",
});
root.render(
  <Router>
    <ThemeProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>

      <ToastContainer
        enableMultiContainer
        position="top-right"
        autoClose={3000}
        newestOnTop={false}
        closeOnClick={true}
        containerId={"main"}
        hideProgressBar={true}
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="light"
        closeButton={false}
        transition={TopTORight}
      />

      <ToastContainer
        enableMultiContainer
        position="top-center"
        autoClose={3000}
        newestOnTop={false}
        closeOnClick={true}
        containerId={"tips"}
        hideProgressBar={true}
        rtl={false}
        pauseOnFocusLoss
        draggable
        limit={1}
        theme="light"
        closeButton={false}
      />
    </ThemeProvider>
  </Router>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
